import { Injectable } from '@angular/core';
import { RestApiService } from '../angular-service/helper.httpServices';
import { LocalStorageService } from '../angular-service/local-storage.service';
import { GLOBAL } from '../global';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: RestApiService,
    private localStorage: LocalStorageService
  ) {}

  userData(requestData: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.authUrl + 'auth/customer/details', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  contactData(requestData: any, reCaptchaToken: string) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          GLOBAL.url + 'contact/customer/create',
          requestData,
          reCaptchaToken
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  updateUserProfile(requestData: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.authUrl + 'auth/customer/update', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  changePassword(requestData: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(GLOBAL.authUrl + 'auth/customer/password/change', requestData)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}
